export enum SortOrder {
    Descending = "descending",
    Ascending = "ascending",
}
